import { ComponentType } from 'react';
import { IOption } from '../Select.types';

export const convertArrayToOptions = (arr: string[]) => {
  const options: IOption[] = arr.map(el => ({
    value: el,
    label: el,
  }));

  return options;
};

export const convertObjectToOptions = (objEnum: object) => {
  const keys = Object.keys(objEnum);
  const values = Object.values(objEnum);

  const options = keys.map((key, idx) => {
    const option = {
      value: values[idx],
      label: key,
    };

    return option;
  });

  return options;
};

export const addDataIdAttribute =
  <P extends object>(Component: ComponentType<P>, dataId: string) =>
  // eslint-disable-next-line react/display-name
  (props: P & { innerProps: unknown }) =>
    (
      <Component
        {...props}
        innerProps={{
          ...props.innerProps!,
          ['data-id']: dataId,
        }}
      />
    );
